import React, { useEffect, useState } from "react";

import {
  InterruptedService,
  MaintenanceEmail,
  MdmProjectInputInput,
  MeasurementTypeDef,
  useGetProjectQuery,
  useUpdateProjectMutation,
} from "gql/generated/types";
import { useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { Button } from "primereact/button";
import MaintenanceConfiguration from "./MaintenanceConfiguration";
import { apolloErrorToaster, successToaster } from "../../utils/utils";

const MaintenanceSettings: React.FC = () => {
  const [emails, setEmails] = useState<MaintenanceEmail[]>([]);
  const [interruptedServices, setInterruptedServices] = useState<InterruptedService[]>([]);

  const { projectId } = useParams();

  const { data } = useGetProjectQuery({ variables: { id: projectId! }, skip: !projectId });

  const [updateProjectMutation] = useUpdateProjectMutation({
    onCompleted: () => successToaster(T("alert.project-updated-successfully")),
    onError: apolloErrorToaster,
  });

  useEffect(() => {
    if (data) {
      setEmails(
        (data.mdmProjectById?.configuration?.maintenanceConfiguration.emails ?? []) as MaintenanceEmail[]
      );
      setInterruptedServices(
        (data.mdmProjectById?.configuration?.maintenanceConfiguration?.interruptedServices ??
          []) as InterruptedService[]
      );
    }
  }, [data]);

  const handleSubmit = () => {
    if (data) {
      const { filterInfo, ...projectConfig } = data.mdmProjectById;
      const project: MdmProjectInputInput = {
        ...projectConfig,
        configuration: {
          ...projectConfig?.configuration!,
          maintenanceConfiguration: {
            emails,
            interruptedServices,
          },
        },
      };
      updateProjectMutation({ variables: { project } });
    }
  };

  return (
    <div className="my-6 flex flex-column gap-6">
      <MaintenanceConfiguration
        deviceRoles={
          (data?.mdmProjectById?.configuration?.deviceConfiguration
            ?.measurementTypes as MeasurementTypeDef[]) ?? []
        }
        emails={emails}
        setEmails={setEmails}
        interruptedServices={interruptedServices}
        setInterruptedServices={setInterruptedServices}
      />
      <div className="flex w-full justify-content-end gap-3">
        <Button
          type="submit"
          onClick={handleSubmit}
          label={T("action.update")}
          className="p-button-rounded p-button-primary w-10rem"
        />
      </div>
    </div>
  );
};

export default MaintenanceSettings;
